"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CommonLibUtils = void 0;
var deep_object_diff_1 = require("deep-object-diff");
var hyper_utils_1 = require("hyper-utils");
var CommonLibUtils = /** @class */ (function () {
    function CommonLibUtils() {
    }
    CommonLibUtils.isDeepEqual = function (obj1, obj2) {
        var objDiff = (0, deep_object_diff_1.diff)(obj1, obj2);
        if (!objDiff)
            return false; // Null or undefined diff means there is diff.
        return Object.keys(objDiff).length === 0;
    };
    CommonLibUtils.deepDiff = function (obj1, obj2) {
        return (0, deep_object_diff_1.diff)(obj1, obj2);
    };
    CommonLibUtils.objectDiff = function (obj1, obj2, options) {
        if (options === void 0) { options = {}; }
        if (options.CaseInsensitive) {
            for (var key in obj1) {
                if (typeof obj1[key] === "string")
                    obj1[key] = obj1[key].toLowerCase();
            }
            for (var key in obj2) {
                if (typeof obj2[key] === "string")
                    obj2[key] = obj2[key].toLowerCase();
            }
        }
        return (0, deep_object_diff_1.diff)(obj1, obj2);
    };
    CommonLibUtils.calculatePercentageAndTrim = function (value, percentage) {
        return hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(value, percentage), 2);
    };
    /** This method will round up if more then 5 and down for Less then or equal 5 */
    CommonLibUtils.roundSpecialCollectionAllowanceForState = function (num, decimalPlaces) {
        if (isNaN(Number(num)))
            return num;
        /** This is special case where state is doing wrong Round down instead of round up.
         * $325 taxable amount on their site gives 8.12 vs 8.13
         * Regex: If number ends with X.X25XX then round down
         */
        if (/\..25|.85|.65/.test(num))
            return Math.floor(num * 100) / 100;
        return parseFloat(num
            .toLocaleString(undefined, {
            maximumFractionDigits: decimalPlaces,
            minimumFractionDigits: decimalPlaces
        })
            .replace(/\,/g, ""));
        // let divider = 1;
        // for (let i = 0; i < decimalPlaces; i++) {
        //   divider *= 10;
        // }
        // let IntermediateNumber = (num * divider) / 10;
        // if (IntermediateNumber - Math.floor(IntermediateNumber) > 0.5)
        //   return Math.ceil(num * divider) / divider;
        // else return Math.floor(num * divider) / divider;
    };
    CommonLibUtils.parseNumber = function (value) {
        if (typeof value === "number")
            return value;
        if (typeof value === "string") {
            value = value.replace(/[^0-9.-]+/g, "");
            return parseFloat(value);
        }
        return parseFloat(value);
    };
    CommonLibUtils.GroupBy = function (array, keys, options) {
        if (options === void 0) { options = {}; }
        if (typeof keys === "string") {
            return array.reduce(function (rv, x) {
                var key = (x[keys] || "").toString();
                (rv[key] = rv[key] || []).push(x);
                return rv;
            }, {});
        }
        return array.reduce(function (rv, x) {
            var groupKey = keys
                .map(function (key) { var _a; return ((_a = x[key]) === null || _a === void 0 ? void 0 : _a.toString()) || ""; })
                .join(options.GroupJoinChar !== undefined ? options.GroupJoinChar : "_");
            (rv[groupKey] = rv[groupKey] || []).push(x);
            return rv;
        }, {});
    };
    CommonLibUtils.GroupBySingle = function (array, key) {
        return array.reduce(function (rv, x) {
            rv[x[key]] = x;
            return rv;
        }, {});
    };
    CommonLibUtils.GetDistinct = function (array, key) {
        var grouped = CommonLibUtils.GroupBy(array, key);
        return Object.keys(grouped);
    };
    CommonLibUtils.undefinedToNull = function (data) {
        if (typeof data === "object") {
            for (var key in data) {
                if (data[key] === undefined)
                    data[key] = null;
                if (typeof data[key] === "object") {
                    this.undefinedToNull(data[key]);
                }
            }
        }
        return data;
    };
    CommonLibUtils.waitForFunction = function (fn, timeout, options) {
        if (options === void 0) { options = {
            interval: 1000
        }; }
        return __awaiter(this, void 0, void 0, function () {
            var interval, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        interval = options.interval;
                        count = 0;
                        _a.label = 1;
                    case 1:
                        if (!(count < timeout)) return [3 /*break*/, 4];
                        return [4 /*yield*/, fn()];
                    case 2:
                        if (_a.sent())
                            return [2 /*return*/, true];
                        count += interval;
                        return [4 /*yield*/, this.wait(interval)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    CommonLibUtils.wait = function (timeout) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(function () {
                            resolve(true);
                        }, timeout);
                    })];
            });
        });
    };
    CommonLibUtils.calculateEntropy = function (str) {
        var freqMap = {};
        var len = str.length;
        // Count frequency of each character
        for (var i = 0; i < len; i++) {
            var char = str[i];
            freqMap[char] = (freqMap[char] || 0) + 1;
        }
        // Calculate entropy
        var entropy = 0;
        for (var char in freqMap) {
            var probability = freqMap[char] / len;
            entropy -= probability * Math.log2(probability);
        }
        return entropy;
    };
    CommonLibUtils.isEncryptedValue = function (text, threshold) {
        if (threshold === void 0) { threshold = 4.5; }
        if (!text)
            return false;
        var entropy = this.calculateEntropy(text);
        // console.log(entropy >= threshold, entropy, threshold, text);
        return entropy >= threshold;
    };
    CommonLibUtils.prettyPrice = function (amount) {
        if (!amount)
            amount = 0;
        if (!amount.toFixed) {
            amount = parseInt(amount);
        }
        return amount.toLocaleString("en-US", {
            style: "currency",
            currency: "USD"
        });
    };
    CommonLibUtils.Sort = function (lst, sortBy) {
        return lst.sort(function (a, b) {
            for (var _i = 0, _a = Object.entries(sortBy); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], sortOrder = _b[1];
                var aValue = a[key];
                var bValue = b[key];
                if (aValue < bValue) {
                    return sortOrder === "asc" ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortOrder === "asc" ? 1 : -1;
                }
            }
            return 0;
        });
    };
    CommonLibUtils.IsValidEmail = function (Email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(Email === null || Email === void 0 ? void 0 : Email.toString());
    };
    CommonLibUtils.GenerateRandomNumber = function (length) {
        var min = Math.pow(10, length - 1);
        var max = Math.pow(10, length) - 1;
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    CommonLibUtils.MaskEmail = function (email) {
        var atIndex = email.indexOf("@");
        if (atIndex !== -1) {
            var username = email.substring(0, atIndex);
            var domain = email.substring(atIndex + 1);
            // Masking logic for the username
            var maskedUsername = "";
            for (var i = 0; i < username.length; i++) {
                if (i === 0 || (i + 1) % 4 === 0) {
                    maskedUsername += username[i];
                }
                else {
                    maskedUsername += "*";
                }
            }
            // Extract the first character of the domain
            var firstCharDomain = domain.charAt(0);
            // Extract the top-level domain (TLD)
            var tldIndex = domain.lastIndexOf(".");
            var tld = domain.substring(tldIndex);
            // Return the masked email address
            return maskedUsername + "@" + firstCharDomain + "******" + tld;
        }
        return email; // Return the original email if '@' is not found
    };
    CommonLibUtils.MaskMobile = function (phoneNumber) {
        var maskedLength = Math.max(phoneNumber.length - 4, 0); // Keep the last 4 digits unmasked
        var maskedPart = "*".repeat(maskedLength);
        return maskedPart + phoneNumber.slice(-4); // Concatenate the masked part with the last 4 digits
    };
    CommonLibUtils.GenerateRandomString = function (length) {
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var randomString = "";
        for (var i = 0; i < length; i++) {
            var randomIndex = Math.floor(Math.random() * characters.length);
            randomString += characters[randomIndex];
        }
        return randomString;
    };
    CommonLibUtils.getLastDigit = function (str, lastDigit) {
        var _a;
        return ((_a = str === null || str === void 0 ? void 0 : str.toString()) === null || _a === void 0 ? void 0 : _a.substr(str.length - lastDigit, lastDigit)) || "";
    };
    CommonLibUtils.GenerateStrongPassword = function (length) {
        if (length === void 0) { length = 12; }
        var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lowercase = "abcdefghijklmnopqrstuvwxyz";
        var specialCharacters = "!@#$%^&*_-";
        var numbers = "0123456789";
        var alphanumeric = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        if (length < 12) {
            throw new Error("Password length should be at least 12 characters");
        }
        var password = "";
        // First character - uppercase letter
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
        // Next 5 characters - lowercase letters
        for (var i = 0; i < 5; i++) {
            password += lowercase[Math.floor(Math.random() * lowercase.length)];
        }
        // Next 2 characters - special characters from !@#$%^&*_
        for (var i = 0; i < 2; i++) {
            password +=
                specialCharacters[Math.floor(Math.random() * specialCharacters.length)];
        }
        // Next 2 characters - numeric characters
        for (var i = 0; i < 2; i++) {
            password += numbers[Math.floor(Math.random() * numbers.length)];
        }
        // Remaining characters - alphanumeric with mixed case
        var remainingLength = length - 10; // 1 uppercase + 5 lowercase + 2 special characters + 2 numbers = 10
        for (var i = 0; i < remainingLength; i++) {
            password += alphanumeric[Math.floor(Math.random() * alphanumeric.length)];
        }
        return password;
    };
    CommonLibUtils.IsStrongPassword = function (password) {
        var minLength = 12;
        var upperCaseRegex = /[A-Z]/;
        var lowerCaseRegex = /[a-z]/;
        var numberRegex = /[0-9]/;
        var specialCharRegex = /[!@#$%^&*]/;
        if (password.length < minLength) {
            return false;
        }
        if (!upperCaseRegex.test(password) || !lowerCaseRegex.test(password)) {
            return false;
        }
        if (!numberRegex.test(password) || !specialCharRegex.test(password)) {
            return false;
        }
        return true;
    };
    CommonLibUtils.FindPercentageOfValue = function (Value, OutOf) {
        if (OutOf === 0) {
            return 0;
        }
        return (Value / OutOf) * 100;
    };
    CommonLibUtils.isNumber = function (number) {
        return !Number.isNaN(Number(number));
    };
    /** Convert JS Name to Beauty Name
     * e.g. MonthlyRevenueReport => Monthly Revenue Report
     *      IsActive => Is Active
     * @param Name - The name to convert
     * @returns The converted name
     */
    CommonLibUtils.BeautyName = function (Name) {
        if (!Name)
            return "";
        // Add space before any capital letters, except the first one
        var beautifiedName = Name.replace(/([A-Z])/g, " $1").trim();
        // Capitalize the first letter
        beautifiedName =
            beautifiedName.charAt(0).toUpperCase() + beautifiedName.slice(1);
        return beautifiedName;
    };
    return CommonLibUtils;
}());
exports.CommonLibUtils = CommonLibUtils;
if (globalThis)
    globalThis.CommonLibUtils = CommonLibUtils;
//# sourceMappingURL=CommonLibUtils.js.map